import React, { useState, useEffect } from 'react';
import { Button, Card, Row, Col, Carousel, Input, notification } from 'antd';
import axios from 'axios';
import { API_URL as PRODUCTO_API_URL } from '../../apis/apiProductos'; // Ajusta según tu configuración de API
import { API_URL as MARCA_API_URL } from '../../apis/apiMarcas';
import './tienda.css';

const Tienda = () => {
  const [productos, setProductos] = useState([]);
  const [filteredProductos, setFilteredProductos] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [filteredMarcas, setFilteredMarcas] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchProductos = async () => {
      try {
        const response = await axios.get(PRODUCTO_API_URL);
        const productosFiltradosPorEstado = response.data.filter(
          (producto) => producto.estado === 1
        );
        setProductos(productosFiltradosPorEstado);
        setFilteredProductos(productosFiltradosPorEstado);
      } catch (error) {
        console.error('Error al obtener productos:', error);
      }
    };

    const fetchMarcas = async () => {
      try {
        const response = await axios.get(MARCA_API_URL);
        setMarcas(response.data);
      } catch (error) {
        console.error('Error al obtener marcas:', error);
      }
    };

    fetchProductos();
    fetchMarcas();
  }, []);

  const filtrarPorCategoria = (categoriaId) => {
    const productosFiltrados = productos.filter(
      (producto) => producto.categoria === categoriaId
    );
    setFilteredProductos(productosFiltrados);
    setCategoriaSeleccionada(categoriaId);

    if (categoriaId === 1) {
      setFilteredMarcas(
        marcas.filter((marca) => [1, 2, 3, 4, 5].includes(marca.id))
      );
    } else if (categoriaId === 2) {
      setFilteredMarcas(marcas.filter((marca) => [7, 8].includes(marca.id)));
    } else if (categoriaId === 3) {
      setFilteredMarcas(
        marcas.filter((marca) => [6, 9, 10, 11, 12].includes(marca.id))
      );
    }
  };

  const filtrarPorMarca = (marcaId) => {
    const productosFiltradosPorMarca = productos.filter(
      (producto) =>
        producto.marca === marcaId &&
        producto.categoria === categoriaSeleccionada
    );
    setFilteredProductos(productosFiltradosPorMarca);
  };

  const mostrarTodosLosProductos = () => {
    setFilteredProductos(productos);
    setFilteredMarcas([]);
    setCategoriaSeleccionada(null);
  };

  const manejarCotizacion = (producto) => {
    const cotizacionesGuardadas =
      JSON.parse(localStorage.getItem('cotizaciones')) || [];
    cotizacionesGuardadas.push(producto);
    localStorage.setItem('cotizaciones', JSON.stringify(cotizacionesGuardadas));

    notification.success({
      message: 'Producto agregado',
      description: `El producto ${producto.nombre} ha sido agregado a la cotización.`,
      placement: 'topRight',
    });
  };

  const onSearchChange = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    const productosFiltrados = productos.filter((producto) =>
      producto.nombre.toLowerCase().includes(term)
    );
    setFilteredProductos(productosFiltrados);
  };

  return (
    <section>
      <div className="catalogo-container">
        <div className="tienda-busqueda-container">
          <h2 className="tienda-busqueda-title">Catálogo de Productos</h2>

          {/* Barra de búsqueda */}
          <div className="tienda-busqueda-busqueda">
            <Input
              placeholder="¿Qué estás buscando?"
              value={searchTerm}
              onChange={onSearchChange}
              className="search-input"
            />
          </div>

          {/* Botones para filtrar productos por categoría */}
          <div className="tienda-busqueda-botones">
            <Button
              type="default"
              className="filter-button"
              onClick={mostrarTodosLosProductos}
            >
              Ver Todo
            </Button>
            <Button
              type="primary"
              className="filter-button"
              onClick={() => filtrarPorCategoria(1)}
            >
              Ver Máquinas
            </Button>
            <Button
              type="primary"
              className="filter-button"
              onClick={() => filtrarPorCategoria(2)}
            >
              Ver Agujas
            </Button>
            <Button
              type="primary"
              className="filter-button"
              onClick={() => filtrarPorCategoria(3)}
            >
              Ver Utilería
            </Button>
          </div>

          {/* Botones para filtrar productos por marca */}
          {filteredMarcas.length > 0 && (
            <div className="tienda-busqueda-botones-filtro">
              {filteredMarcas.map((marca) => (
                <Button
                  key={marca.id}
                  type="dashed"
                  className="filter-button"
                  onClick={() => filtrarPorMarca(marca.id)}
                >
                  {marca.nombre}
                </Button>
              ))}
            </div>
          )}
        </div>

        <div className="Tienda-productos">
          {/* Mostrar los productos filtrados */}
          <Row gutter={[16, 16]}>
            {filteredProductos.length > 0 ? (
              filteredProductos.map((producto) => (
                <Col key={producto.id} xs={24} sm={12} md={8} lg={6}>
                  <Card
                    hoverable
                    style={{
                      marginBottom: '20px',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Carousel autoplay pauseOnHover>
                      {producto.imagenes.map((imagen) => (
                        <div key={imagen.id}>
                          <img
                            alt={`Imagen de ${producto.nombre}`}
                            src={imagen.imagen}
                            style={{
                              width: '100%',
                              height: '200px',
                              objectFit: 'contain',
                            }}
                          />
                        </div>
                      ))}
                    </Carousel>

                    <Card.Meta
                      title={producto.nombre}
                      description={
                        <>
                          <p>{producto.modelo}</p>
                          <p>Descripción: {producto.descripcion}</p>
                        </>
                      }
                    />
                    <Button
                      type="primary"
                      style={{ marginTop: '10px' }}
                      onClick={() => manejarCotizacion(producto)}
                    >
                      Cotizar
                    </Button>
                  </Card>
                </Col>
              ))
            ) : (
              <p style={{ textAlign: 'center', width: '100%' }}>
                No hay productos disponibles para esta categoría, marca o
                búsqueda.
              </p>
            )}
          </Row>
        </div>
      </div>
    </section>
  );
};

export default Tienda;
